import { Button, Col, Form, Modal, notification, Pagination, Row, Spin, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { employeeService } from '../../../../services';
import { useNavigate } from 'react-router-dom';

function User() {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [employees, setEmployees] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 12,
    });
    const [id, setID] = useState(null)

    const handleCancel = () => {
        form.resetFields()
        setID(null)
        setDeleteModal(false)
    };

    const handleDelete = (id) => {
        setID(id)
        setDeleteModal(true)
    }

    const handleOk = async () => {
        setDeleteLoading(true)
        const response = await employeeService.deleteEmployee(id)
        setDeleteLoading(false)
        if (response?.success ?? false) {
            notification.success({
                message: "User deleted Successfully."
            })
            initialize();
            setID(null)
        }
        setDeleteModal(false)
    }

    const initialize = async (page = 1, pageSize = pagination.pageSize) => {
        setLoading(true);
        const { success, data } = await employeeService.fetch(page, pageSize);
        setLoading(false);
        if (success) {
            setEmployees(data.data);
            setPagination((prev) => ({
                ...prev,
                total: data.total,
                current: page,
                pageSize,
            }));
        }
    };

    useEffect(() => {
        document.title = "Ctrade - Employees"
        initialize()
    }, [])

    return (
        <div>
            <Row gutter={24} style={{ border: "1px solid #D9D9D9", display: "flex", alignItems: "center", backgroundColor: "#FFFFFF", padding: "12px", borderRadius: "8px" }}>
                <Col span={12} style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    Manage Employees
                </Col>
                <Col span={12} style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}>
                    <Button type="primary" onClick={() => navigate(`/staff/user/form`)}> Add Employee </Button>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: "25px" }}>
                {loading ?
                    <div className="flex justify-center min-w-full min-h-[50vh] items-center">
                        <Spin spinning={loading} size={"large"} tip="Loading..." />
                    </div>
                    :
                    <>
                        {employees.map((data, index) => (
                            <Col xs={24} sm={12} md={8} lg={6} xl={6} style={{ marginTop: "25px" }}>
                                <Card
                                    style={{
                                        width: "100%", // Adjust width dynamically
                                        // maxWidth: "250px", // Limit max width
                                        height: 320,
                                        borderRadius: "12px",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                        textAlign: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        padding: "6px",
                                    }}
                                    actions={[

                                        <div >
                                            <Tooltip title='Edit'>
                                                <EditOutlined key="edit" onClick={() => navigate(`/staff/user/form/${data.id}`)} />
                                            </Tooltip>
                                        </div>,
                                        <div >
                                            <Tooltip title="View">
                                                <EyeOutlined key="View" onClick={() => navigate(`/staff/user/view/${data.id}`)} />
                                            </Tooltip>
                                        </div>,
                                        <div >
                                            <Tooltip title="Delete">
                                                <DeleteOutlined key="Delete" onClick={() => handleDelete(data.id)} />
                                            </Tooltip>
                                        </div>
                                    ]}
                                >

                                    <div
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            marginBottom: "15px",
                                            marginRight: "auto",
                                            marginLeft: "auto",
                                        }}
                                    >
                                        <img
                                            src="/images/empview.png"
                                            alt="User"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                    {/* Roles */}
                                    <div style={{ marginTop: 16, fontWeight: "bold", fontSize: "16px" }}>
                                        {/* <UserOutlined style={{ marginRight: 8 }} /> */}
                                        {data.title}
                                    </div>
                                    <div style={{
                                        marginTop: 8,
                                        width: "100%",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        fontSize: "18px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontWeight: "bold",
                                    }}>
                                        {data?.name}
                                    </div>

                                    {/* Name */}
                                    <div style={{ marginTop: 8, fontSize: "14px", fontWeight: "bold", color: "#555", textTransform: "capitalize" }}>
                                        {data.role}
                                    </div>

                                    {/* Email */}
                                    <div style={{ marginTop: 8, fontSize: "14px", fontWeight: "bold", color: "#555" }}>
                                        {data?.username}
                                    </div>

                                    {/* Date */}
                                    <div style={{ marginTop: 8, fontSize: "14px", color: "#555" }}>
                                        <strong>Last Logged In:</strong>
                                        <br />
                                        {data?.last_logged_in}
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </>
                }
            </Row>
            <Row style={{ marginTop: 20 }}>
                <Col span={24} style={{ display: 'flex', justifyContent: "right" }}>
                    <Pagination
                        current={pagination.current}
                        total={pagination.total}
                        onChange={(number) => { initialize(number) }}
                        pageSize={pagination.pageSize}
                    />
                </Col>
            </Row>

            {/* delete modal */}
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={deleteModal}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                style={{
                    padding: "20px",
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                            style={{ width: "30%" }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" onClick={handleOk} style={{ width: "30%" }} loading={deleteLoading}>
                            Confirm
                        </Button>
                    </div>
                }
            >
                <p style={{ textAlign: "center" }}>
                    Are you sure you want to delete this User?
                </p>
            </Modal>
        </div>
    )
}

export default User
